type Props = {
  percentage: string | number | null;
  roundColor?: string | undefined;
  className?: string;
};
function PercentageCircle(props: Props) {
  const { percentage, roundColor, className } = props;
  let color = !roundColor ? "#ff0606" : roundColor;
  const per = Number(percentage);

  if (percentage && !roundColor) {
    if (per > 0 && per < 25) {
      color = "#ff0606";
    }
    if (per > 25 && per < 50) {
      color = "#ffa206";
    }
    if (per > 50 && per < 75) {
      color = "#060fff";
    }
    if (per > 75 && per <= 100) {
      color = "#15A687";
    }
  }
  return (
    <>
      <div className="w-full flex justify-center items-center">
        <div
          className={`h-[48px] w-[48px] rounded-full flex justify-center items-center ${className}`}
          role="progressbar"
          aria-valuenow={75}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{
            color: color,
            background: `radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(${
              roundColor ? color.trim() : color
            } ${per}%, ${roundColor ? color.trim() + "67" : color.concat('67') } 0)`,
          }}
        >
          <div className="m-1">{per.toFixed()}%</div>
        </div>
      </div>
    </>
  );
}

export default PercentageCircle;
